export const ECOMMERCE = 1;
export const ANDROID = 2;
export const IOS = 3;
export const SHOPIFY = 4;
export const NEW_SHOPIFY = 5;

const ECOMMERCE_NAME = "eCommerce";
const ANDROID_NAME = "Android";
const IOS_NAME = "iOS";
const SHOPIFY_NAME = "Shopify";
const NEW_SHOPIFY_NAME = "Shopify 2.0";

export const getPlatformNameById = (id) => {
  const platformName = {
    [ECOMMERCE]: ECOMMERCE_NAME,
    [ANDROID]: ANDROID_NAME,
    [IOS]: IOS_NAME,
    [SHOPIFY]: SHOPIFY_NAME,
    [NEW_SHOPIFY]: NEW_SHOPIFY_NAME,
  };
  return platformName[id];
};
